import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Dashboard } from './pages/Dashboard';
import { OnboardingForm } from './pages/OnboardingForm';
import { AuthProvider, useAuth } from './contexts/AuthContext';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated
  } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" data-id="element-10" />;
}
function AppRoutes() {
  return <Routes data-id="element-11">
      <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
      <Route path="/login" element={<Login data-id="element-15" />} data-id="element-14" />
      <Route path="/signup" element={<Signup data-id="element-17" />} data-id="element-16" />
      <Route path="/onboarding" element={<OnboardingForm data-id="element-19" />} data-id="element-18" />
      <Route path="/dashboard" element={<ProtectedRoute data-id="element-21">
            <Dashboard data-id="element-22" />
          </ProtectedRoute>} data-id="element-20" />
    </Routes>;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-23">
      <AuthProvider data-id="element-24">
        <AppRoutes data-id="element-25" />
      </AuthProvider>
    </BrowserRouter>;
}